import { Select } from '@creditornot/cb-select';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { localize } from 'common/utils';

import { useExperienceModuleContext } from '../../context';
import { useExperienceEntityChildren } from '../../hooks/useExperienceEntityChildren';
import { ExperienceEntityType } from '../../types';

const StyledSelect = styled(Select)`
  min-width: 300px;
  z-index: 10;
`;

export const EntitySelector = () => {
  const { experienceEntity, selectedExperienceEntity, setSelectedExperienceEntity } = useExperienceModuleContext();
  const subExperienceEntities = useExperienceEntityChildren();
  const { locale, formatMessage } = useIntl();

  const entitySelectItems = [
    {
      label: formatMessage({
        id: 'experience.search.filter.all',
      }),
      value: experienceEntity.experienceEntityId,
    },
  ].concat(
    subExperienceEntities
      .filter(subExperienceEntity => {
        if (subExperienceEntity.experienceEntityType === ExperienceEntityType.VENUE) {
          return subExperienceEntity.experienceEntityObject.status === 'VENUE_PUBLISHED';
        }
        return true;
      })
      .map(subExperienceEntity => {
        const label =
          typeof subExperienceEntity.experienceEntityObject.name === 'string'
            ? subExperienceEntity.experienceEntityObject.name
            : localize(subExperienceEntity.experienceEntityObject.name, locale);
        const entityType =
          subExperienceEntity.experienceEntityType.charAt(0).toUpperCase() +
          subExperienceEntity.experienceEntityType.slice(1);
        return {
          label: label.concat(` (${entityType})`),
          value: subExperienceEntity.experienceEntityId,
        };
      }),
  );

  const handleEntityChange = (value: string) => {
    if (value === experienceEntity.experienceEntityId) {
      setSelectedExperienceEntity(experienceEntity);
      return;
    }
    const newEntity = subExperienceEntities.find(entity => entity.experienceEntityId === value);
    if (newEntity) {
      setSelectedExperienceEntity(newEntity);
    }
  };

  return (
    <StyledSelect
      options={entitySelectItems}
      value={selectedExperienceEntity.experienceEntityId}
      onChange={handleEntityChange}
    ></StyledSelect>
  );
};
